import type { Error } from '../types';
import { CANADIAN_ZIP_CODE_FORMAT } from '../utils/regex';

import { TXTWCL_Please_enter_a_valid_postcode__ELL } from './zipCodeFormatCAON.messages';

export const zipCodeFormatCAON =
  () =>
  (value: string): Error => ({
    valid: CANADIAN_ZIP_CODE_FORMAT.test(value),
    message: TXTWCL_Please_enter_a_valid_postcode__ELL
  });
